import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { Content } from "@/types/content";
import { UseToastOptions } from "@chakra-ui/react";

 type GenGraph = "txt2img" | "ESRGAN"
 export type ProgressImage = {
  dataURL: string;
  width: number;
  height: number;
};

 export interface DesignState {
  currentImage: Content;
  genGraph:GenGraph;
  esrgan:string;
  progressImage: ProgressImage|null;
  isProcessing:boolean;
  toastQueue: UseToastOptions[];
}

const initialState:DesignState = {
  currentImage: {} as Content,
  genGraph: "txt2img",
  esrgan: "",
  progressImage: null,
  isProcessing: false,
  toastQueue: [],
};

export const designSlice = createSlice({
  name: "design",
  initialState,
  reducers: {
    setCurrentImage: (state, action: PayloadAction<Content>) => {
      state.currentImage = action.payload;
    },
    genGraph:(state,action:PayloadAction<GenGraph>)=>{
      state.genGraph = action.payload
    },
    runESRGAN:(state,action:PayloadAction<string>)=>{
      state.esrgan = action.payload
    },
    progressImageSet:(state,action:PayloadAction<ProgressImage|null>)=>{
      state.progressImage = action.payload
    },
    setIsProcessing:(state,action:PayloadAction<boolean>)=>{
      state.isProcessing = action.payload
    },
    addToast: (state, action: PayloadAction<UseToastOptions>) => {
      state.toastQueue.push(action.payload);
    },
  },

});

// Action creators are generated for each case reducer function
export const { setCurrentImage,genGraph, runESRGAN,progressImageSet,addToast} = designSlice.actions;

export default designSlice.reducer;

export const selectCurrentImage = (state: RootState) => state.design.currentImage;
export const selectProgressImage = (state: RootState) => state.design.progressImage;
export const selectIsProcessing = (state: RootState) => state.design.isProcessing;
